import { AxiosError } from 'axios'
import { toast } from 'sonner'

export function handleServerError(error: unknown) {
  if (import.meta.env.DEV && import.meta.env.MODE !== 'test') {
    // eslint-disable-next-line no-console
    console.log('[handleServerError]', error)
  }

  let errMsg = 'Something went wrong!'

  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    Number(error.status) === 204
  ) {
    errMsg = 'Content not found.'
  }

  if (error instanceof AxiosError) {
    const dataMessage = error.response?.data?.message
    const formattedMessage = Array.isArray(dataMessage)
      ? dataMessage.join(', ')
      : dataMessage

    errMsg =
      error.response?.data?.title ||
      formattedMessage ||
      error.message ||
      'An error occurred'
  } else if (error instanceof Error) {
    errMsg = error.message || 'Something went wrong!'
  }

  // Only show toast if we have a valid error message
  if (errMsg && typeof errMsg === 'string' && errMsg.trim()) {
    toast.error(errMsg)
  } else if (errMsg && typeof errMsg !== 'string') {
    // Handle non-string error messages
    toast.error('An error occurred')
  }
}
